import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { SEARCH_QUERY as PUBLIC_SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationPublicRpc.dfc.new';
import { SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc.dfc.new';
import { useAppliedFilters } from '../../filters/hooks/useAppliedFilters';
import { usePersonalizationQuery } from '../../hooks/usePersonalizationQuery';
import { useProductTypes } from '../../hooks/useProductTypeSearchParams';
import { SORT_OPTIONS } from '../components/SortDropdown';
import { DATA_TYPE_MAP, mapSortForRpc, parseAppliedFilterValues } from '../utils/searchMappers';
import { useCollectionQuery } from './useCollectionQuery';
export const LISTINGS_PER_PAGE = 60;
const SEARCH_TIMEOUT_MS = 10000;
export function useSearchResultsQuery() {
  var _collectionResult$dat, _collectionResult$dat2, _searchResult$data;
  const collectionResult = useCollectionQuery();
  const collectionId = collectionResult.isUmbrellaCollection ? undefined : (_collectionResult$dat = collectionResult.data) === null || _collectionResult$dat === void 0 ? void 0 : _collectionResult$dat.id;
  const collectionSlug = collectionResult.isUmbrellaCollection ? undefined : (_collectionResult$dat2 = collectionResult.data) === null || _collectionResult$dat2 === void 0 ? void 0 : _collectionResult$dat2.slug;
  const searchResult = usePersonalizationQuery({
    app: SEARCH_QUERY,
    public: PUBLIC_SEARCH_QUERY,
    options: {
      context: {
        timeout: SEARCH_TIMEOUT_MS
      },
      skip: collectionResult.loading || !!collectionResult.error,
      variables: {
        collectionId,
        filter: useFilter(),
        length: LISTINGS_PER_PAGE,
        offset: useOffset(),
        queryType: useQueryType(),
        search: useSearchParams().get('search'),
        sorts: useSorts()
      }
    }
  });
  return {
    loading: collectionResult.loading || searchResult.loading,
    error: collectionResult.error || searchResult.error,
    data: searchResult.data,
    queryType: (_searchResult$data = searchResult.data) !== null && _searchResult$data !== void 0 && _searchResult$data.result.queryType ? String(searchResult.data.result.queryType) : undefined,
    collectionId,
    collectionSlug
  };
}
function useFilter() {
  const productTypes = useProductTypes();
  const appliedFilters = useAppliedFilters();
  const filtersByField = {};
  for (const filter of appliedFilters) {
    if (filter.field === 'PRODUCT_TYPE') {
      continue;
    }
    filtersByField[filter.field] = [{
      values: parseAppliedFilterValues(filter),
      clause: 'OR',
      negation: false,
      __typename: DATA_TYPE_MAP[filter.dataType]
    }];
  }
  filtersByField.PRODUCT_TYPE = [{
    values: productTypes,
    clause: 'OR',
    negation: false,
    __typename: DATA_TYPE_MAP.STRING
  }];
  return {
    filterGroups: [{
      filtersByField,
      clause: 'AND',
      negation: false
    }],
    clause: 'AND',
    negation: false
  };
}
function useOffset() {
  const params = useSearchParams();
  const page = Number(params.get('page')) || 1;
  return (page - 1) * LISTINGS_PER_PAGE;
}
function useQueryType() {
  const params = useSearchParams();
  return params.get('queryType', {
    allowedValues: ['ELASTIC_SEARCH', 'VAAS', 'LLM']
  });
}
function useSorts() {
  const params = useSearchParams();
  const sort = params.get('sort', {
    allowedValues: Object.keys(SORT_OPTIONS)
  });
  return mapSortForRpc(sort);
}